import type { Step } from '../types/step';
import type { AppData } from '../../types/app_data';
import { AddCarYearStep } from '../onboarding/addcaryear.step';
import { AddCarOnboardingSteps } from '../onboarding/addcars.step';
import { CarsStep } from '../onboarding/cars.step';
import { DriversStep } from '../onboarding/drivers.step';
import { AddDriverStep } from '../onboarding/adddriver';
import { AddDriverSelectNameStep } from '../onboarding/adddriverselectname';
import { AddDriverEnterNameStep } from '../onboarding/adddriverentername';
import { OccupationStep } from '../onboarding/occupation.step';
import { OccupationDriverStep } from '../onboarding/occupationDriver.step';
import { OccupationListStep } from '../onboarding/occupationList.step';
import { OccupationListDriverStep } from '../onboarding/occupationListDriver.step';
import { EducationStep } from '../onboarding/education.step';
import { EmailStep } from '../onboarding/email.step';

import { ConfirmAddressStep } from './confirmaddress.step';
import { UpdateDobFailureStep } from './updatedobfailure.step';
import { UpdateDobSuccessStep } from './updatedobsuccess.step';
import { UpdateDobCarStep } from './updatedobcar.step';
import { UpdateDobCarrierStep } from './updatedobcarrier.step';
import { ChallengeDobStep } from './challengedob.step';
import { ChallengeStep } from './challenge.step';

export const getChallengeSteps = (flowType?: AppData['flowType']): Step[] => {
  const steps: Step[] = [
    ChallengeStep,
    ChallengeDobStep,

    // Update DOB challenges
    UpdateDobCarrierStep,
    UpdateDobCarStep,
    UpdateDobSuccessStep,
    UpdateDobFailureStep,

    ConfirmAddressStep,

    AddCarYearStep,
    ...AddCarOnboardingSteps,
    CarsStep,

    DriversStep,
    AddDriverStep,
    AddDriverSelectNameStep,
    AddDriverEnterNameStep,

    // For Geico Quotes
    OccupationStep,
    OccupationDriverStep,
    OccupationListStep,
    OccupationListDriverStep,
    EducationStep,
    EmailStep,
  ];

  return steps;
};
